import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=35920c6c&scoped=true&lang=pug"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=35920c6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35920c6c",
  null
  
)

export default component.exports